import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import { useLocation, useNavigate } from "react-router-dom";
import PackagesService from "../../../../../services/PackagesService";

const AddPackage = () => {
	const location = useLocation();
	const [formData, setFormData] = useState({
		name_en: "",
		name_ar: "",
		feature_en: "",
		feature_ar: "",
		price: false,
		monthly_price: "",
		annually_price: "",
	});
	const navigate = useNavigate();
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const packagesService = new PackagesService();

	useEffect(() => {
		if (!location?.state) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			let state = location?.state;
			setFormData({
				id: state?.id,
				name_en: state?.name_en,
				name_ar: state?.name_ar,
				feature_en: state?.feature_en,
				feature_ar: state?.feature_ar,
				monthly_price: state?.monthly_price || "",
				annually_price: state?.annually_price || "",
				status: state?.status,
				price: state?.price,
			});
		}
	}, []);

	const submit = (e) => {
		e.preventDefault();

		let data = {
			name_en: formData?.name_en,
			name_ar: formData?.name_ar,
			feature_en: formData?.feature_en,
			feature_ar: formData?.feature_ar,
			price: formData?.price,
		};
		if (formData?.price) {
			data["monthly_price"] = Number(formData?.monthly_price);
			data["annually_price"] = Number(formData?.annually_price);
		}

		setLoading(true);
		if (isAdd) {
			packagesService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						navigate("/packages");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			packagesService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						navigate("/packages");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Row>
			<Col md={10}>
				<div
					className="d-flex align-items-center"
					style={{ gap: "8px", margin: "12px 0 32px" }}>
					<svg
						style={{ cursor: "pointer" }}
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						className="button-back"
						xmlns="http://www.w3.org/2000/svg"
						onClick={() => navigate("/packages")}>
						<path
							d="M9.57 5.92993L3.5 11.9999L9.57 18.0699"
							stroke="#1E1F24"
							strokeWidth="1.5"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M20.4999 12H3.66992"
							stroke="#1E1F24"
							strokeWidth="1.5"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>

					<label
						className="mb-0"
						style={{ fontSize: "20px", fontWeight: "600" }}>
						{!isAdd ? Translate[lang]?.edit : Translate[lang]?.add}{" "}
						{Translate[lang]?.package}
					</label>

					{!isAdd && (
						<Form.Check
							type="switch"
							id="custom-switch"
							checked={formData?.status}
							onChange={(e) =>
								setFormData({ ...formData, status: e.target.checked })
							}
						/>
					)}
				</div>
				<AvForm className="form-horizontal" onValidSubmit={submit}>
					<Row>
						{/* Name En */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.name} ({Translate[lang]?.english})
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name_en"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_en}
								onChange={(e) =>
									setFormData({
										...formData,
										name_en: e.target.value,
									})
								}
							/>
						</Col>
						{/* Name Ar */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.name} ({Translate[lang]?.arabic})
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name_ar"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_ar}
								onChange={(e) =>
									setFormData({
										...formData,
										name_ar: e.target.value,
									})
								}
							/>
						</Col>
						{/* Features En */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.features} ({Translate[lang]?.english})
							</label>
							<AvField
								type="textarea"
								placeholder={Translate[lang]?.english}
								bsSize="lg"
								style={{
									height: "150px",
								}}
								name="feature_en"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.feature_en}
								onChange={(e) =>
									setFormData({
										...formData,
										feature_en: e.target.value,
									})
								}
							/>
						</Col>
						{/* Features Ar */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.features} ({Translate[lang]?.arabic})
							</label>
							<AvField
								type="textarea"
								placeholder={Translate[lang]?.features}
								bsSize="lg"
								name="feature_ar"
								style={{
									height: "150px",
								}}
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.feature_ar}
								onChange={(e) =>
									setFormData({
										...formData,
										feature_ar: e.target.value,
									})
								}
							/>
						</Col>
						{/* Price */}
						<Col md={12}>
							<label>{Translate[lang]?.price}</label>
							<Form.Check
								type="switch"
								id="price"
								checked={formData?.price}
								onChange={(e) =>
									setFormData({ ...formData, price: e.target.checked })
								}
							/>
						</Col>
						{formData?.price && (
							<Col md={12} className="mt-3">
								<Row className="packages-price">
									<Col md={6}>
										<label className="text-label">
											{Translate[lang]?.monthly}
										</label>
										<AvField
											type="number"
											placeholder={Translate[lang]?.amount}
											bsSize="lg"
											name="monthly_price"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.monthly_price}
											onChange={(e) =>
												setFormData({
													...formData,
													monthly_price: e.target.value,
												})
											}
										/>
									</Col>
									<Col md={6}>
										<label className="text-label">
											{Translate[lang]?.annual}
										</label>
										<AvField
											type="number"
											placeholder={Translate[lang]?.amount}
											bsSize="lg"
											name="annually_price"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.annually_price}
											onChange={(e) =>
												setFormData({
													...formData,
													annually_price: e.target.value,
												})
											}
										/>
									</Col>
								</Row>
							</Col>
						)}
					</Row>
					<Row>
						<Col md={6} className="mt-4">
							<Button
								variant="primary"
								type="submit"
								className="w-100"
								disabled={loading}>
								{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
								{Translate[lang]?.package}
							</Button>
						</Col>
					</Row>
				</AvForm>
			</Col>
		</Row>
	);
};

export default AddPackage;
